import { createFileRoute, Outlet } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';

export const Route = createFileRoute('/_authenticated/organizations')({
  component: Outlet,
  loader: () => ({
    breadcrumb: t`Organizations`,
  }),
});
